var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3674_5182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44444 8.5H6.84444C5.84889 8.5 5.35111 8.5 4.97067 8.69075C4.63617 8.85853 4.36422 9.12623 4.19378 9.4555C4 9.83 4 10.32 4 11.3V16.2C4 17.18 4 17.67 4.19378 18.0445C4.36422 18.3738 4.63617 18.6415 4.97067 18.8093C5.35022 19 5.848 19 6.84178 19H17.1582C18.152 19 18.6489 19 19.0284 18.8093C19.3636 18.6413 19.6356 18.3735 19.8062 18.0445C20 17.67 20 17.1818 20 16.2035V11.2974C20 10.3191 20 9.82913 19.8062 9.4555C19.6356 9.1261 19.3633 8.85838 19.0284 8.69075C18.6489 8.5 18.1511 8.5 17.1556 8.5H15.5556M8.44444 8.5H15.5556M8.44444 8.5C8.44444 7.57174 8.81905 6.6815 9.48584 6.02513C10.1526 5.36875 11.057 5 12 5C12.943 5 13.8474 5.36875 14.5142 6.02513C15.181 6.6815 15.5556 7.57174 15.5556 8.5",
    stroke: "#008080",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3674_5182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientGreen);
export default __webpack_public_path__ + "static/media/Client_Green.cbe693a66f030f5df3c41915e156278e.svg";
export { ForwardRef as ReactComponent };